import VueCqrs from '@cqrs/vue-component-cqrs';
import * as q from '@Quest/CorporateAttributes/Domain/queries';
import { Component } from 'vue-facing-decorator';

@Component
export default class CorporateAttributesQueries extends VueCqrs
{
	runManageAllPageQueryV1(workspaceId: number, strategyId: string)
	{
		const query = q.buildManageAllPageQueryV1(workspaceId, strategyId);
		this.$query(query);
	}
}